<template>
  <div class="task" ref="task">
    <my-head title="交通车管理"/>
    
    <!-- <mu-text-field v-model="value" placeholder="" disabled class='search'>
      <i class="iconfont icon-search"></i>
      </mu-text-field> -->

    <mu-paper :z-depth="1" class="loadmore-wrap" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
      <mu-container ref="container" class="loadmore-content">
        <mu-load-more :refreshing="refreshing" @refresh="refresh">
          <mu-container>
            <mu-paper :z-depth="1">
              <mu-data-table stripe :loading="tableLoading" :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" :data="list" @row-click="rowTap">
                <template slot-scope="scope">
                  <td>{{scope.row.code}}</td>
                  <td>{{scope.row.quantity}}</td>
                  <td>{{scope.row.date}}</td>
                  <td>{{scope.row.statue}}</td>
                </template>
              </mu-data-table>
            </mu-paper>
          </mu-container>
        </mu-load-more>
      </mu-container>
    </mu-paper>
  </div>
</template>

<script>
import myHead from '@/components/header'
import api from "@/common/api"
export default {
  name: 'task',
  data () {
    return {
      num: 10,
      refreshing: false,
      text: 'List',
      loading: false,
      tableLoading: true,
      value: '',
      wrapperHeight: 0,
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
          { title: '订单',  name: 'code' , width: 100},
          { title: '数量', name: 'quantity', align: '', width: 50},
          { title: '叫车时间', name: 'date',  align: ''},
          { title: '状态', name: 'status',  align: '', width: 80}
      ],
      list: [],
      requestOnce: true
    }
  },
  components: {
    myHead
  },
  methods: {
    rowTap (index, row, event) {
      localStorage.setItem("trafficcarlistid", row.id);
      this.$router.push({name:"trafficcarlist", params: {id: row.id}});
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    refresh () {
      // 下拉刷新
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      this.list = [];
      this.resData(0);
    },
    load () {
      // 上啦更新
      this.loading = true;
    },
    resData (count) {
      /* 发送post请求 */
      let data = Object.assign({},this.$store.state.user,{content: {count: count}});
      if(this.requestOnce){
        this.requestOnce = false;
        this.common.reqData(api.app('trafficCarQuery'), data, res=>{
          this.requestOnce = true;
          let datas = res.data;
          if(datas.status == 100){
            this.tableLoading = false;
            this.refreshing = false;
            for(let item of datas.content.tasks){
              this.list.push(item);
            }
          }else{
            this.tableLoading = false;
            this.refreshing = false;
            console.log(res.data)
          }
        },err =>{
          this.tableLoading = false;
          this.refreshing = false;
          this.requestOnce = true;
          console.log(err)
        });
      }
    }
  },
  mounted () {
    // 确定高度
    this.wrapperHeight = document.documentElement.clientHeight - 45
    this.resData(0);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  padding: 0;
}
.mu-table td.executioning{
  color: red;
}
.mu-table td.completed{
  color: green;
}
.search{
  display: block;
  margin: 10px auto ;
  width: 90%;
}
.search input{
  padding: 0 ;
}
.loadmore-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.loadmore-wrap .mu-appbar {
    width: 100%;
}
.loadmore-content {
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.mu-paper.mu-paper-round.mu-elevation-1{
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/trafficCar/trafficCar.vue